interface EmailData {
  email: string;
}

export const sendWelcomeEmail = async (data: EmailData) => {
  const response = await fetch('/api/welcome-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = result?.error || 'Error al enviar el email';
    const details = result?.details;
    if (details) console.error('Detalle del servidor:', details);
    throw new Error(message);
  }

  return result;
}; 